/**
 * main.tsx — Dev harness entry point for billing-admin
 *
 * Purpose:
 *   Mounts the billing admin console widget into the document body during
 *   local development. This file is NOT part of the library build — it is
 *   only used by the Vite dev server (index.html → main.tsx).
 *
 * @since 2026-05-31 (AT-50.01 — Scaffold Admin Console UI Foundation)
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import type { AdminConfig } from './index';

const searchParams = new URLSearchParams(window.location.search);

const devConfig: AdminConfig = {
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL
    ?? searchParams.get('apiBaseUrl')
    ?? window.location.origin,
  basename: searchParams.get('basename') ?? '/admin/billing',
};

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App config={devConfig} />
  </React.StrictMode>,
);
